import { Color } from 'molstar/lib/mol-util/color';
import AsyncLock from "async-lock";

/**
 * Normalize color
 * @param colorVal - color
 * @param defaultColor - color to be used as default
 */
export function normalizeColor(colorVal: any, defaultColor?: Color): Color {
  let color = Color.fromRgb(170, 170, 170);
  try {
    if (typeof colorVal.r !== 'undefined') {
      color = Color.fromRgb(colorVal.r, colorVal.g, colorVal.b);
    } else if (colorVal[0] === '#') {
      color = Color(Number(`0x${colorVal.substring(1)}`));
    } else {
      color = Color(colorVal);
    }
  } catch (e) {
    if (defaultColor) color = defaultColor;
  }
  return color;
}

export const lock = new AsyncLock();